var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "payment-options" } },
    [
      _c(
        "button",
        {
          staticClass: "button-primary",
          attrs: { id: "add-tip" },
          on: {
            click: function ($event) {
              return _vm.$router.push({ name: "Tip" })
            },
          },
        },
        [
          _c("table", [
            _c("tr", [
              _c("td", { staticClass: "action-label" }, [_vm._v("Tip")]),
              _c("td", { staticClass: "action-value" }, [
                _vm._v(_vm._s(_vm._f("toCurrency")(_vm.tip))),
              ]),
              _vm._m(0),
            ]),
          ]),
        ]
      ),
      _vm.isBraintree
        ? [
            _c(
              "button",
              {
                staticClass: "button-secondary payment-type-button",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "CreditCardBraintree" })
                  },
                },
              },
              [_vm._v("Credit Card")]
            ),
            _c("BraintreeGooglePay"),
            _c("BraintreeApplePay"),
          ]
        : _vm._e(),
      _vm.isPayeezy
        ? [
            _c(
              "button",
              {
                staticClass: "button-secondary payment-type-button",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "CreditCardPayeezy" })
                  },
                },
              },
              [_vm._v("Credit Card")]
            ),
            _c("GenericGooglePay"),
            _c("PayeezyApplePay"),
          ]
        : _vm._e(),
      _vm.isShift4
        ? [
            _c(
              "button",
              {
                staticClass: "button-secondary payment-type-button",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({ name: "CreditCardShift4" })
                  },
                },
              },
              [_vm._v("Credit Card")]
            ),
            _c("Shift4ApplePayGooglePay"),
          ]
        : _vm._e(),
      _vm.isAuthorizeNet
        ? [
            _c("div", { staticClass: "payment-buttons-container-text" }, [
              _vm._v("Select a payment method:"),
            ]),
            _c(
              "div",
              { staticClass: "payment-buttons-container" },
              [
                _c(
                  "button",
                  {
                    staticClass: "secondary-option-button",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "CreditCardAuthorizeNet",
                        })
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "pi pi-credit-card app-credit-card-icon",
                    }),
                    _c("div", { staticStyle: { display: "inline-block" } }, [
                      _vm._v("Credit Card"),
                    ]),
                  ]
                ),
                _vm.isGooglePayEnabled ? _c("GenericGooglePay") : _vm._e(),
                _vm.isApplePayEnabled ? _c("GenericApplePay") : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "action-icon" }, [
      _c("img", {
        staticClass: "button-caret",
        attrs: { src: require("@/assets/images/caret-right-white.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }